import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import html2canvas from 'html2canvas';
import PDF from 'jspdf';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import htmlToPdfmake from 'html-to-pdfmake';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import MonthTable from './MonthTable';
import CategorySalesByMonth from './CategorySalesByMonth';
import { getCategorySalesData, handleLoader } from '../../../../redux/actions/CategorySalesAction';
import { months } from '../../CompareMonth/helper';
import { setCurrencyFormat, findMonthsBetweenDates, getMonths } from '../../../../utils/helpers';
import ViewSalesReportModal from './ViewSalesReportModal';
import { filterShowWise, vendorNameMapping, sortType } from '../../helper';

const CategorySales = ({ dispatch, rtl, vendor }) => {
  const location = useLocation();

  const currentYear = moment().format('YYYY');
  const preYear = moment().subtract(1, 'years').format('YYYY');
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(6, 'months').format('MMM');

  const { categorySalesData, salesChannelFilterData, isLoading } = useSelector(
    ({ categorySalesReducer, marketPlaceReducer }) =>
    ({
      categorySalesData: categorySalesReducer?.[vendor]?.categorySalesData,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      isLoading: categorySalesReducer?.[vendor]?.isLoading
    })
  );
  const [dataToShow, setDataToShow] = useState(categorySalesData?.modal?.data?.[0]?.yearlySales);
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0])
  const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth })
  const [month1, setMonth1] = useState({ year: preYear, month: prevMonth });
  const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
  const [tempMonth1, setTempMonth1] = useState({ year: preYear, month: prevMonth })


  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));

  const date1 = `${month1?.year}-${month1?.month}`;
  const date2 = `${month2?.year}-${month2?.month}`;

  const selectedFromMonth = month1.month;
  const selectedFromYear = month1.year;
  const selectedToMonth = month2.month;
  const selectedToYear = month2.year;

  const selectFromDate = selectedFromMonth + selectedFromYear;
  const selectToDate = selectedToMonth + selectedToYear;
  const selectedMonths = getMonths(moment(selectFromDate, 'MMMYYYY'), moment(selectToDate, 'MMMYYYY'))

  const allCategories = {}
  const currentDataByCategory = {};
  let dataToShowForDatesSelected = [];


  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const printDocument = () => {
    const doc = new PDF();   
  //  const dvTb = document.getElementById('dvTable');
  //  dvTb.style.display = "none";     
    const pdfDoc = document.getElementById('divToPrint');   
    const html = htmlToPdfmake(pdfDoc.innerHTML);
    const documentDef = {pageSize: 'B4', pageOrientation: 'landscape', 
    pageMargins: [ 5, 0, 5, 0 ], content: [html],   
   };
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
  //  dvTb.style.display = "block";  
    pdfMake.createPdf(documentDef).download('Category_Sales.pdf');   
   
}

  const divToPDF = (e) => {
    const but = e.target;
    but.style.display = "none";
   // const input = window.document.getElementsByClassName("dvPdf")[0];
   const input = document.getElementById('divToPrint');
  
    html2canvas(input).then((canvas) => {
      const img = canvas.toDataURL('image/png');
      console.log(img)
      const pdf = new PDF("landscape", "pt", "A4");
      const imgProps = pdf.getImageProperties(img);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
     // const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(
        img,
        "png",
        0,
        0,
        pdfWidth,
        pdfHeight
        // input.offsetLeft,
        // input.offsetTop,
        // input.offsetWidth,
        // input.offsetHeight
      );
    //  pdf.autoTable({html: '#divToPrint'})
    pdf.setFont('verdana', 'normal');

    const docDefinition = {
      content: [{
        image: img,
      }]
    }
    pdfMake.createPdf(docDefinition).download("Score_Details.pdf")
    //  pdf.save("Profit_Report.pdf");
      but.style.display = "block";
    });
  };
const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 10,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvTb = document.getElementById('dvTable');
    const dvChartF = document.getElementById('dvChartFilter');
    const dvChartV = document.getElementById('dvChartView');
    dvTb.style.display = "none";  
    dvChartF.style.display = "none";  
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: 40,
      fileName: `Category Sales Report ${new Date().getFullYear()}`,
    })
    dvTb.style.display = "block";  
    dvChartF.style.display = "block";  
    dvChartV.style.display = "block"; 
  }

  const handleApplyDate = () => {
    const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
    const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

    const monthsBetween = findMonthsBetweenDates(startDate, endDate);
    if (monthsBetween?.length > 0) {
      setMonth1(tempMonth1);
      setMonth2(tempMonth2);
      dispatch(handleLoader(true, vendor));
      dispatch(getCategorySalesData({ from: tempMonth1?.year, to: tempMonth2?.year, vendor }));
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Please select minimum two months'
        });
      });
    }
  }

  const handleYearMonthChange = ({ isFrom, field, value }) => {

    if (isFrom) {
      setTempMonth1({ ...tempMonth1, [field]: value?.value });
    } else {
      setTempMonth2({ ...tempMonth2, [field]: value?.value })
    }
  }

  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="12" md="4">
      <Row className="justify-content-space-between">
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Year</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                  : { value: tempMonth2?.year, label: tempMonth2?.year }}
                options={yearOptions}
                clearable={false}
                placeholder="Select Year"
                className="select_filter-110"
                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'from' : 'to'}
              />
            </div>

          </div>
        </Col>
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Month</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                  : { value: tempMonth2?.month, label: tempMonth2?.month }}
                options={monthOptions}
                clearable={false}
                placeholder="Select Month"
                className="select_filter-110"
                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'fromMonth' : 'toMonth'}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );

  const changeFilter = (value) => {
    setCurrentlyShow(value)
  };

  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  );


  const reduceCallback = (acc, day) => {
    const date = moment(`${day.salesMonth}-${day?.salesYear}`, 'MMM-YYYY');
    const MonthYear = date.format('MMM-YYYY');
    if (acc[MonthYear]) {
      acc?.[MonthYear]?.push(day)
    } else {
      acc[MonthYear] = [day]
    }

    if (day && !allCategories[day?.[currentlyShow?.value]]) {
      if (!day?.[currentlyShow?.value] || day?.[currentlyShow?.value] === 'null') {
        allCategories['N/A'] = 'N/A';
      } else {
        allCategories[day?.[currentlyShow?.value]] = day?.[currentlyShow?.value]
      }
    }
    return acc
  }


  useEffect(() => {
    dispatch(handleLoader(true, vendor));
    dispatch(getCategorySalesData({ from: tempMonth1?.year, to: tempMonth2?.year, vendor }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(categorySalesData?.modal?.data?.[0]?.yearlySales);
  }, [categorySalesData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])

  const monthsBetweenDates = findMonthsBetweenDates(date1, date2);
  for (let i = 0; i < monthsBetweenDates.length; i += 1) {
    const [year, month] = monthsBetweenDates?.[i]?.split('-');
    let monthWiseData = dataToShow?.[year]?.monthlyProductSales?.[month] ?? [];
    if (monthWiseData) {
      monthWiseData = monthWiseData.filter(item =>
        filterBasedOnFilter(item))?.map(item => ({
          ...item,
          salesMonth: month,
          salesYear: year
        }))
      dataToShowForDatesSelected = dataToShowForDatesSelected?.concat(monthWiseData);

    }
  }

  dataToShowForDatesSelected.forEach((item) => {
    if (item && currentDataByCategory[item?.[currentlyShow?.value]]) {
      currentDataByCategory[item?.[currentlyShow?.value]]?.push(item)
    } else if (item) {
      if (!item?.[currentlyShow?.value] || item?.[currentlyShow?.value] === 'null') {
        currentDataByCategory?.['N/A']?.push(item)
      } else {
        currentDataByCategory[item?.[currentlyShow?.value]] = [item]
      }
    }
  });

  const currentMonthCat = Object.keys(currentDataByCategory);
  const dataToPlot = [];

  for (let i = 0; i < currentMonthCat.length; i += 1) {
    const cat = currentMonthCat[i];
    const currentMonthData = currentDataByCategory?.[cat] ?? [];

    const currentYearMonthDayWise = currentMonthData?.reduce(reduceCallback, {})
    const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
      let amount = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
        Number(item.amount)).toFixed(2)), 0);
      const quantity = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
        Number(item.quantity)).toFixed(2)), 0);
      amount = Math.abs(amount);
      acc[monthyear] = { Amount: amount, Qty: quantity };
      return acc
    }, {})

    dataToPlot.push({
      title: cat,
      categoryWiseAmountTotal,
    })

  }

  const dataToShowForExcel = [];
  const dataToShowForExcelWithQty = [];
  const tableHeader = [];

  dataToPlot?.forEach((dataValue, index) => {
    const subData = {}
    const subDataWithQty = {}
    subData.title = dataValue?.title;
    subDataWithQty.title = dataValue?.title;

    if (index === 0) {
      tableHeader.push({
        Header: currentlyShow?.label,
        accessor: 'title',
        disableGlobalFilter: false,
        width: 150,
        sortType
      })
    }
    
    selectedMonths?.forEach((month) => {
      subData[month] = setCurrencyFormat(dataValue?.categoryWiseAmountTotal?.[month]?.Amount, true);
      subDataWithQty[month] = setCurrencyFormat(dataValue?.categoryWiseAmountTotal?.[month]?.Qty, false);
      if (index === 0) {
        tableHeader.push({
          Header: month,
          accessor: month,
          disableGlobalFilter: false,
          width: 120,
          sortType
        })
      }
    });
    dataToShowForExcel.push(subData)
    dataToShowForExcelWithQty.push(subDataWithQty)
  });
  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">{vendorNameMapping[vendor]} Category Sales By Month</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">
                <Col sm="6" md="3">
                  <div className="form__form-group mb-0">
                    <span className="form__form-group-label">Show</span>
                    <div className="form__form-group-field">
                      <Select
                        value={currentlyShow}
                        options={filterShowWise}
                        clearable={false}
                        placeholder="Select "
                        className="select_filter-show-based"
                        onChange={value => changeFilter(value)}
                        classNamePrefix="react-select"
                      />
                    </div>

                  </div>
                </Col>
                <Col sm="12" md="9">
                  <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />
                    <Col sm='1' className="filter-to-position">~</Col>
                    <RenderYearAndMonth />
                    <Col sm="3" className="p-0 filter-to-position">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button> 
                        <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                    </Col>                   
                  </Row>
                </Col>
               
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
      <Row className="show-categ-month-wise-sales">
        <Col xs="12">
          <Card className="pb-3 show-categ-daily-sales">
            <CardBody>
              {isLoading ? (
                <>
                  <div className="card__title">
                    <h5 className="bold-text">
                      {`Category sales by month and ${currentlyShow?.label}`}</h5>
                  </div>
                  <div
                    style={{ minHeight: '200px' }}
                    className="row align-items-center justify-content-center"
                  >
                    <SmallLoader loading={isLoading} />
                  </div>
                </>) : (
                <MonthTable
                  dataToShowForDatesSelected={dataToShowForDatesSelected}
                  month={selectedMonths}
                  categorisedBasedOn={currentlyShow?.value}
                  title={`Category sales by month and ${currentlyShow?.label}`}
                  firstColumn={currentlyShow?.label}
                  currentlyShow={currentlyShow}
                />)}
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row className="show-sales-category">
        <Col xs="12">
          <Card className="pb-3 show-categ-daily-sales">
            <CardBody>
              {isLoading ? (
                <>
                  <div className="card__title">
                    <h5 className="bold-text">
                      {`Category Sales By ${currentlyShow?.label}`}</h5>
                  </div>
                  <div
                    style={{ minHeight: '200px' }}
                    className="row align-items-center justify-content-center"
                  >
                    <SmallLoader loading={isLoading} />
                  </div>
                </>) : (
                <CategorySalesByMonth
                  dir={rtl.direction}
                  dataToShowForDatesSelected={dataToShowForDatesSelected}
                  height={450}
                  title={`Category Sales By ${currentlyShow?.label}`}
                  viewReportButton={viewReportButton}
                  monthsBetweenDates={selectedMonths}
                  categorisedBasedOn={currentlyShow?.value}
                  isSalesKey='amount'
                  currentlyShow={currentlyShow}
                />)}
            </CardBody>
          </Card>

        </Col>
      </Row>
      </div>
      <ViewSalesReportModal
        modalData={dataToShowForExcel}
        modalDataQty={dataToShowForExcelWithQty}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        fileName={`${vendorNameMapping[vendor]} Category Sales By ${currentlyShow?.label} Report`}
        fileNameQty={`${vendorNameMapping[vendor]} Category Sales By ${currentlyShow?.label} Quantity Report`}
        title={`${vendorNameMapping[vendor]} Category Sales By ${currentlyShow?.label} Report`}
      />
    </Container>
  );
};

CategorySales.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(CategorySales);